import {
  GET_HDF_CONFIGURATION_BEGIN,
  GET_HDF_CONFIGURATION_SUCCESS,
  GET_HDF_CONFIGURATION_ERROR,
  SAVE_GENERAL_HDF_BEGIN,
  SAVE_GENERAL_HDF_SUCCESS,
  SAVE_GENERAL_HDF_ERROR,
} from "./actions";
import humps from "humps";

const initialState = {
  rawData: {},
  hdfData: {},
  initialValues: {},
  maxMemberHistory: 1,
  isFetching: false,
  error: null,
};

const getMaxMemberHistoryNumber = obj => {
  if (!obj) return 1;
  const regex = /memberHistory_(\d+)/;
  return Object.keys(obj)
    .filter(key => key.startsWith("memberHistory_"))
    .reduce((max, key) => {
      const number = parseInt(regex.exec(key)[1]);
      return Math.max(max, number);
    }, 1);
};

const formatEligibleMembers = members => {
  return members.map(member => {
    return Object.fromEntries(
      Object.entries(member).map(([key, value]) => {
        let newKey = `${humps.camelize(member.relationshipDetail)}_${key}`;
        return [newKey, value];
      })
    );
  });
};
const formatInitials = data => {
  if (data.formData) return { ...data.formData };
  let result = { formId: data.config.formId };

  if (data.companyInfo) {
    result = { ...result, ...data.companyInfo };
  }
  if (data.employeeInfo) {
    result = { ...result, ...data.employeeInfo };
  }
  if (Array.isArray(data.eligibleMembers) && data.eligibleMembers.length > 0) {
    const eligibleDependantMembers = data.eligibleMembers.filter(
      member => member.type !== "Employee"
    );
    const formattedDependantMembers = formatEligibleMembers(eligibleDependantMembers);
    formattedDependantMembers.forEach((member, idx) => {
      result = { ...result, ...member };
    });
    const spouseMember = data.eligibleMembers.find(
      member => member.type === "Dependant" && member.relationship === "Spouse"
    );
    if (spouseMember) {
      result = { ...result, hasSpouse: "Yes" };
    }
  }

  return result;
};

const formatHDFData = data => {
  if (Array.isArray(data.eligibleMembers) && data.eligibleMembers.length > 0) {
    const eligibleDependantMembers = data.eligibleMembers.filter(
      member => member.type !== "Employee"
    );

    if (eligibleDependantMembers.length <= 0) {
      return {
        ...data,
        isCompleted: !!(data.formData && data.formData.consentDeclaration),
        config: {
          ...data.config,
          pages: data.config.pages.filter(page => page.pageId !== "dependantInformation"),
        },
      };
    }
  }
  return {
    ...data,
    isCompleted: !!(data.formData && data.formData.consentDeclaration),
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HDF_CONFIGURATION_BEGIN:
    case SAVE_GENERAL_HDF_BEGIN:
      return { ...state, isFetching: true };
    case GET_HDF_CONFIGURATION_ERROR:
    case SAVE_GENERAL_HDF_ERROR:
      return { ...state, isFetching: false, error: action.payload };
    case GET_HDF_CONFIGURATION_SUCCESS:
      return {
        ...state,
        rawData: action.payload,
        hdfData: formatHDFData(action.payload),
        initialValues: formatInitials(action.payload),
        maxMemberHistory: getMaxMemberHistoryNumber(action.payload.formData),
        isFetching: false,
      };
    case SAVE_GENERAL_HDF_SUCCESS:
      return {
        ...state,
        hdfData: {
          ...state.hdfData,
          formData: action.payload.formData,
          isCompleted: !!(action.payload.formData && action.payload.formData.consentDeclaration)
        },
        initialValues: { ...action.payload.formData },
        maxMemberHistory: getMaxMemberHistoryNumber(action.payload.formData),
        isFetching: false,
      };
    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/reducer.js